export default __webpack_public_path__ + "static/media/placeholder_store04-it-web.736b4818.png";